import { useLocation, Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";

const TITLES = {};

export default function PlaceholderPage() {
  const { pathname } = useLocation();
  const title = TITLES[pathname] || "Page";

  return (
    <main className="flex min-h-screen flex-col bg-[#0A2647]">
      <Navbar />
      <div className="flex flex-1 flex-col items-center justify-center px-6 text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.45em] text-[#F47221]">
          Coming soon
        </p>
        <h1
          className="mt-4 font-display text-4xl font-semibold text-white md:text-5xl"
          data-testid="placeholder-title"
        >
          {title}
        </h1>
        <p className="mt-4 max-w-md text-sm text-[#D6EBEE]/70">
          [This section is a placeholder — content will be added here.]
        </p>
        <Link
          to="/"
          data-testid="placeholder-home-link"
          className="mt-8 text-xs font-semibold uppercase tracking-[0.3em] text-white underline decoration-[#F47221] underline-offset-8 transition-colors hover:text-[#F47221]"
        >
          Back to Home
        </Link>
      </div>
    </main>
  );
}
